const isSafeReason = (value) => typeof value === 'string'
    && value.length <= 240
    && !/payload\s*=|error\s*=|\{\s*"?(method|code|data)"?\s*:/i.test(value)

const getErrorText = (error) => {
    if (typeof error === 'string') return isSafeReason(error) ? error : ''
    if (!error || typeof error !== 'object') return ''
    return [error.reason, error.shortMessage].find(isSafeReason) || ''
}

export function mapStakingError(error, t = (value) => value) {
    const message = getErrorText(error).trim()
    const knownMessage = [message, error?.message, error?.error?.message].filter(Boolean).join(' ')
    if (error?.code === 4001 || /rejected|denied|cancelled/i.test(knownMessage)) return t('您已取消钱包操作')
    if (/not reach/i.test(knownMessage)) return t('未到达解锁时间')
    if (/not wl/i.test(knownMessage)) return t('邀请用户暂未质押代币, 无法绑定上下级关系')
    if (/insufficient funds|insufficient balance|balance too low|exceeds balance/i.test(knownMessage)) return t('余额不足')
    return message || t('交易失败，请稍后重试')
}
